module.exports = __webpack_public_path__ + "img/light_rightImg.99efb21a.png";